module.exports = __webpack_public_path__ + "static/media/d5ru.8bb01554.pdf";